import {
  ROBUST_ASSESSMENT_MODEL,
  ROBUST_ASSESSMENT_SCHEMA_VERSION,
} from "@/components/assessment/robustAssessmentData";

export const CURRENT_ASSESSMENT_SCHEMA_VERSION = ROBUST_ASSESSMENT_SCHEMA_VERSION;
export const CURRENT_ASSESSMENT_MODEL = ROBUST_ASSESSMENT_MODEL;

export const assessmentSchemaVersion = (assessment = {}) =>
  Number(
    assessment.schemaVersion ||
      assessment.v ||
      assessment.answers?.meta?.assessmentSchemaVersion ||
      assessment.a?.meta?.assessmentSchemaVersion,
  ) || 0;

export const assessmentModel = (assessment = {}) =>
  assessment.assessmentModel ||
  assessment.answers?.meta?.assessmentModel ||
  assessment.a?.meta?.assessmentModel ||
  null;

export const needsRobustAssessmentUpgrade = (assessment = {}) =>
  assessmentSchemaVersion(assessment) < CURRENT_ASSESSMENT_SCHEMA_VERSION ||
  assessmentModel(assessment) !== CURRENT_ASSESSMENT_MODEL;

export const assessmentUpgradeCopy = {
  eyebrow: "A more robust assessment is available",
  title: "Update your nervous-system baseline",
  body:
    "The new assessment separates reaction strength, usable energy, behavioral control, attention, recovery, environment, connection, physical capacity, and recovery resources more precisely. Your current assessment remains active until the new one is completed.",
};
